Postlogin = (function (self) {
    self.AssessmentAssignmentsXXX = {};
    const me = self.AssessmentAssignmentsXXX;

    me.$assignmentsListTable = $('#assignments-list-table');

    me.initAssignmentsTable = function () {
        const userId = me.$assignmentsListTable.attr('data-user-id');
        const currentUserId = me.$assignmentsListTable.attr('data-current-user-id');
        const userFirstName = me.$assignmentsListTable.attr('data-user-first-name');

        $('#export').on('click', (e) => {
            e.preventDefault();
            const opts = me.$assignmentsListTable.bootstrapTable('getOptions');

            const exportParams = {
                columns: _.map(me.$assignmentsListTable.bootstrapTable('getVisibleColumns'), (col) => col.field),
                order_by: opts.sortName,
                sort_order: opts.sortOrder,
                page_size: 9999999,
            };

            const url = Slim.Router.urlFor('Users.assessmentAssignments.export', {
                user_id: userId,
            });

            window.open(`${url}?${$.param(exportParams)}`, '_blank');
        });

        me.$assignmentsListTable.bootstrapTable({
            formatNoMatches() {
                if (userId === currentUserId) {
                    return 'You have no assessment assignments yet!';
                }

                return `${userFirstName} has no assessment assignments yet`;
            },
            // height: table_height,
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: true,
            search: false,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: userId === currentUserId ? '/my-profile/assessment-assignments/json/' : `/users/${userId}/assessment-assignments/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;

                return myParams;
            },
            columns: [
                {
                    title: 'Assigned',
                    field: 'date_assigned',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assessment Type',
                    field: 'assessment_type',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assigned To',
                    field: 'number_assigned_to',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '% Completed',
                    field: 'percentage_completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    // sr-only title: the column is visually just a
                    // row-action icon set, but screen readers and
                    // axe's empty-table-header rule require a real
                    // accessible header text.
                    title: '<span class="sr-only">Actions</span>',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                me.$assignmentsListTable.closest('.light-blur').removeClass('light-blur');
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $('#number_of_assignments').html(res.meta.total);

                formattedResult.rows.map((result) => {
                    let row = result;
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row = Jr.Utils.convertRowDate(row, 'l', []);

                    row.percentage_complete = row.percentage_completed;

                    row.percentage_completed = `${Math.round(row.percentage_completed * 100) / 100}%`;
                    // row.percentage_completed = row.number_completed + "/" + row.number_assigned_to;

                    const viewUrl = me.$assignmentsListTable.attr('data-view-url');
                    const assignmentViewUrl = viewUrl
                        .replace(':assessment_id', row.assessment_id)
                        .replace(':assignment_id', row.assignment_id);

                    const studentsAssignedTo = row.number_assigned_to;
                    row.number_assigned_to += ' student';
                    if (+studentsAssignedTo !== 1) {
                        row.number_assigned_to += 's';
                    }
                    row.number_assigned_to = `<a href="${assignmentViewUrl}" class="btn btn-hollow-dark-gray">${row.number_assigned_to}</a>`;

                    // if assessment has a subtitle, append it under the Cluster
                    if (row.subtitle) {
                        row.assessment_type += `<br><em>${row.subtitle}</em>`;
                    }

                    row.actions = `<a href="${assignmentViewUrl}" class="btn btn-hollow-green">View</a>`;

                    if (row.can_manage) {
                        const assignmentEditUrl = me.$assignmentsListTable
                            .attr('data-edit-url')
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);
                        const assignmentDeleteUrl = me.$assignmentsListTable
                            .attr('data-delete-url')
                            .replace(':assessment_id', row.assessment_id)
                            .replace(':assignment_id', row.assignment_id);
                        row.actions
                            += ''
                            + `<a href="${assignmentEditUrl}" class="btn btn-hollow-blue">Edit</a>`
                            + `<form action="${assignmentDeleteUrl}" method="post" class="delete-entry">`
                            + `  <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">`
                            + '  <input type="hidden" name="_METHOD" value="DELETE"/>'
                            + '  <button type="submit" class="btn btn-hollow-pink">Delete</button>'
                            + '</form>';
                    }
                    return row;
                });

                return formattedResult;
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
            rowStyle(row) {
                let classes = '';

                if (row.percentage_complete < 33.3333) {
                    classes += 'danger ';
                } else if (row.percentage_complete < 66.6666) {
                    classes += 'warning ';
                } else if (row.percentage_complete < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    me.init = function () {
        me.initAssignmentsTable();
    };

    return self;
}(Postlogin || {}));
